export default "__VITE_ASSET__fUYPtlp7__"